import { useAppSelector } from "@/common/store/redux";

export const useFeatureDisabledList = () => {
  const disabledFeatureFlags = useAppSelector(
    (state) => state.config.disabledFeatureFlags,
  );

  return Array.from(disabledFeatureFlags.keys());
};
